import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { apiGet } from "./client";
import { cardStateSchema, type CardState } from "./schemas";

export type { CardState };

/** /api/v2/cards — sozlesme §5 + kart manifesti §4 (backend/app/core/api/cards.py). */

export const cardSchema = z.object({
  id: z.string(),
  title: z.string(),
  state: cardStateSchema,
  reason: z.string().nullable(),
  warning: z.string().nullable(),
  capability: z.array(z.string()),
  tab: z.string(),
});
export type CardOut = z.infer<typeof cardSchema>;

export const tabSchema = z.object({
  id: z.string(),
  visible: z.boolean(),
});
export type TabOut = z.infer<typeof tabSchema>;

export const cardsResponseSchema = z.object({
  cards: z.array(cardSchema),
  tabs: z.array(tabSchema),
});
export type CardsResponse = z.infer<typeof cardsResponseSchema>;

export function fetchCards(): Promise<CardsResponse> {
  return apiGet("/api/v2/cards", cardsResponseSchema);
}

export const CARDS_QUERY_KEY = ["cards"] as const;

export function useCardsQuery() {
  return useQuery({
    queryKey: CARDS_QUERY_KEY,
    queryFn: fetchCards,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    // Eski refresh.js: sekme acikken 15 dk'da bir arka plan yenileme (duvar ekrani).
    refetchInterval: 15 * 60_000,
  });
}
